'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input-number/style/css');

var _inputNumber = require('antd/lib/input-number');

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _css2 = require('antd/lib/checkbox/style/css');

var _checkbox = require('antd/lib/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundInput = _react2.default.createClass({
    displayName: 'RefundInput',
    getInitialState: function getInitialState() {
        var value = this.props.value || {};
        return {
            checked: value.checked || false,
            money: value.money || 0
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        // Should be a controlled component.
        if ('value' in nextProps) {
            var value = nextProps.value;
            this.setState(value);
        }
    },
    onMoneyChange: function onMoneyChange(money) {
        if (isNaN(money)) {
            return;
        }
        if (!('value' in this.props)) {
            this.setState({
                money: money
            });
        }
        this.triggerChange({
            money: money
        });
    },
    onCheckboxChange: function onCheckboxChange(e) {
        var checked = e.target.checked;
        if (!('value' in this.props)) {
            this.setState({
                checked: checked
            });
        }
        this.triggerChange({
            checked: checked
        });
    },
    triggerChange: function triggerChange(changedValue) {
        // Should provide an event to pass value to Form.
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(Object.assign({}, this.state, changedValue));
        }
    },
    render: function render() {
        var state = this.state;
        return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
                _checkbox2.default,
                { checked: state.checked, onChange: this.onCheckboxChange },
                '\u9000\u6B3E'
            ),
            _react2.default.createElement(_inputNumber2.default, { value: state.money, disabled: !state.checked, onChange: this.onMoneyChange, min: 0, max: this.props.max })
        );
    }
}); /**
     * 退款表单组件，由单选框和数字输入框组成
     */
exports.default = RefundInput;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/refund_input.js
// module id = 1312
// module chunks = 0